import{createDOMMotionComponentProxy as r}from"../create-proxy.mjs.js";import{createMotionComponent as o}from"./create.mjs.js";const m=r(o);export{m as motion};
